import React, { useContext } from 'react';

export const ExpensesCardContext = React.createContext();

export default ExpensesCardContext;

export const useExpensesCardContext = () => useContext(ExpensesCardContext);
